import Link from "next/link";

const BreadCrumb = ({ breadCrumb }) => {
  return (
    <div className="breadCrumb">
      {breadCrumb?.map((item, index) => (
        <Link key={index} href={item.url}>
          {item.title}
        </Link>
      ))}
    </div>
  );
};

export default BreadCrumb;
